import {
  Button,
  Col,
  Dropdown,
  Input,
  Menu,
  PageHeader,
  Row,
  Space,
  Spin,
  Statistic,
  Table,
  Tag
} from "antd";
import { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";

import Admin_edit from "../forms/admin_edit";
import Admin_new from "../forms/admin_new";

import { DELETE, GET, UPDATE } from "../constants/request-type";
import {
  admin,
  delete_admin,
  get_all_admin,
  update_admin
} from "../constants/routes";
import { service_api } from "../constants/url";
import { MakeRequestAsync } from "../functions/axios";
import { decryptSingleData } from "../functions/cryptojs";
import { openNotificationWithIcon } from "../functions/notification";

import logger from "../../utils/logger.js";
const token = sessionStorage.getItem("auth_token");

class AdminAdmin extends Component {
  state = {
    selectedRowKeys: [],
    searchText: "",
    searchedColumn: "",
    load: true,
    data: [],
    overall: true,
    allowed: false,
    blocked: false
  };

  componentDidMount() {
    this.getData();
  }

  getData = async () => {
    const request_details = {
      type: GET,
      url: service_api,
      route: admin + "/" + get_all_admin,
      data: null,
      token: token
    };

    try {
      const response = await MakeRequestAsync(request_details);
      this.setState({
        load: false,
        data: decryptSingleData(response?.data?.admin)
      });
    } catch (err) {
      this.setState({ load: false });
      logger.log(err);
      return openNotificationWithIcon(
        "error",
        `${err?.response?.data?.message}`
      );
    }
  };

  onSelectChange = (selectedRowKeys) => {
    logger.log("selectedRowKeys changed: ", selectedRowKeys);
    this.setState({ selectedRowKeys });
  };

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              this.setState({
                searchText: selectedKeys[0],
                searchedColumn: dataIndex
              });
            }}
          >
            Filter
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      )
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  handleDelete = async (id) => {
    const request_details = {
      type: DELETE,
      url: service_api,
      route: admin + "/" + delete_admin + "/" + id,
      token: token
    };
    try {
      await MakeRequestAsync(request_details);
      return setTimeout(() => window.location.reload(), 1000);
    } catch (err) {
      return openNotificationWithIcon(
        "error",
        `${err?.response?.data?.message}`
      );
    }
  };

  handleStatus = async (id, status) => {
    const data = {
      status: status
    };
    const request_details = {
      type: UPDATE,
      url: service_api,
      route: admin + "/" + update_admin + "/" + id,
      data: data,
      token: token
    };
    try {
      await MakeRequestAsync(request_details);
      return setTimeout(() => window.location.reload(), 1000);
    } catch (err) {
      return openNotificationWithIcon("error", `${err.response.data}`);
    }
  };

  render() {
    const columns = [
      {
        title: "Id",
        dataIndex: "_id",

        ...this.getColumnSearchProps("_id"),
        fixed: "left"
      },
      {
        title: "Nom",
        dataIndex: "firstname",

        ...this.getColumnSearchProps("firstname")
      },
      {
        title: "Prénom",
        dataIndex: "lastname",

        ...this.getColumnSearchProps("lastname")
      },
      {
        title: "Contact",
        dataIndex: "number",

        ...this.getColumnSearchProps("number"),
        render: (text) => {
          return <a href={`tel:${text}`}>{text}</a>;
        }
      },
      {
        title: "Profil",
        dataIndex: "pic",
        render: (text) => {
          return (
            <a href={text} target="_blank" rel="noreferrer">
              <img
                src={text}
                style={{
                  width: 70
                }}
                alt="profil"
              />
            </a>
          );
        }
      },
      {
        title: "Role & Permission",
        dataIndex: "permission",

        render: (text) => {
          return (
            <Tag color={"blue"} key={text.name}>
              {text.name}
            </Tag>
          );
        }
      },
      {
        title: "Actif",
        dataIndex: "status",
        render: (text) =>
          text === false ? (
            <Tag color={"volcano"} key={text}>
              NON
            </Tag>
          ) : (
            <Tag color={"green"} key={text}>
              OUI
            </Tag>
          )
      },
      {
        title: "Création",
        dataIndex: "createdAt",
        render: (text) => <Tag>{text?.slice(0, 16)}</Tag>
      },
      {
        title: "Actions",
        fixed: "right",
        render: (text, record) => (
          <div>
            <Dropdown
              overlay={MenuButton(record)}
              placement="bottomCenter"
              arrow
            >
              <Button>Options</Button>
            </Dropdown>
          </div>
        )
      }
    ];
    const { allowed, blocked, overall } = this.state;

    const MenuButton = (record) => (
      <Menu>
        <Menu.Item>
          <Admin_edit row={record} />
        </Menu.Item>
        {record.status === true ? (
          <Menu.Item>
            <Link onClick={() => this.handleStatus(record._id, false)}>
              Verrouiller
            </Link>
          </Menu.Item>
        ) : (
          <Menu.Item>
            <Link onClick={() => this.handleStatus(record._id, true)}>
              Autoriser
            </Link>
          </Menu.Item>
        )}
        <Menu.Item>
          <Link onClick={() => this.handleDelete(record._id)}>Supprimer</Link>
        </Menu.Item>
      </Menu>
    );
    const { load, data } = this.state;
    return (
      <>
        <PageHeader
          title="Adminstrateurs"
          tags={<Tag color="blue">Liste des admins</Tag>}
          subTitle=""
          extra={[
            <Admin_new />,
            <Button
              key="2"
              color="primary"
              onClick={() =>
                this.setState({
                  allowed: false,
                  blocked: false,
                  verified: false,
                  overall: true
                })
              }
            >
              Tout
            </Button>,
            <Button
              key="2"
              color="primary"
              onClick={() =>
                this.setState({
                  allowed: true,
                  blocked: false,
                  overall: false
                })
              }
            >
              Actif
            </Button>,
            <Button
              key="3"
              color="danger"
              onClick={() =>
                this.setState({
                  allowed: false,
                  blocked: true,
                  overall: false
                })
              }
            >
              Inactif
            </Button>
          ]}
        >
          <Row>
            <Statistic
              title="Actif"
              value={
                data.filter((res) => {
                  return res.status === 0;
                }).length
              }
            />
            <Statistic
              title="Inactif"
              value={
                data.filter((res) => {
                  return res.status === 1;
                }).length
              }
              style={{
                margin: "0 32px"
              }}
            />
            <Statistic title="Total" value={data.length} />
          </Row>
          <Row>
            {load ? (
              <Space size="middle">
                <Spin size="large" />
              </Space>
            ) : (
              <Col span={24}>
                <Table
                  columns={columns}
                  dataSource={data.filter((res) => {
                    if (allowed && !blocked && !overall)
                      return res.status === 0;
                    if (!allowed && blocked && !overall)
                      return res.status === 1;

                    return res;
                  })}
                />
              </Col>
            )}
          </Row>
        </PageHeader>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    admin: state.admin
  };
};

const mapDispatchStoreToProps = () => {
  return {};
};

export default connect(mapStateToProps, mapDispatchStoreToProps)(AdminAdmin);
